// extracted by mini-css-extract-plugin
export default {"container":"FailedToLoadData_container__axgXZ","icon":"FailedToLoadData_icon__+EOty","text":"FailedToLoadData_text__EOf7M"};